import React, {useLayoutEffect, useRef} from 'react';
import {digits} from './membersInputFormats.ts';

/** Mantém o cursor junto dos dígitos ao inserir ou excluir no meio da máscara. */
export default function MembersMaskedField({label, value, onValueChange, ...props}: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> & {
  label: string; value: string; onValueChange: (value: string) => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  const trailingDigits = useRef<number | null>(null);
  useLayoutEffect(() => {
    const node = input.current;
    if (!node || trailingDigits.current === null) return;
    let position = node.value.length;
    let remaining = trailingDigits.current;
    while (position > 0 && remaining > 0) {
      position--;
      if (/\d/.test(node.value[position])) remaining--;
    }
    node.setSelectionRange(position, position);
    trailingDigits.current = null;
  });
  function update(raw: string, cursor: number) {
    trailingDigits.current = digits(raw.slice(cursor)).length;
    onValueChange(raw);
  }
  return <label className="block space-y-2 text-sm">
    <span className="font-medium">{label}{props.required ? ' *' : ''}</span>
    <input {...props} ref={input} value={value} className="members-input w-full min-w-0 text-sm"
      onChange={event => update(event.target.value, event.target.selectionStart ?? event.target.value.length)}
      onKeyDown={event => {
        const node = event.currentTarget;
        const start = node.selectionStart ?? 0;
        if (start !== node.selectionEnd || !['Backspace', 'Delete'].includes(event.key) || event.ctrlKey || event.metaKey || event.altKey) return;
        let index = event.key === 'Backspace' ? start - 1 : start;
        const direction = event.key === 'Backspace' ? -1 : 1;
        while (index >= 0 && index < value.length && !/\d/.test(value[index])) index += direction;
        if (index < 0 || index >= value.length) return;
        event.preventDefault();
        const raw = value.slice(0, index) + value.slice(index + 1);
        update(raw, event.key === 'Backspace' ? index : start);
      }} />
  </label>;
}
